import React from "react";
import { Formik, Form } from "formik";
import { Grid } from "@mui/material";
import FormikDatePicker from "@/components/forms/FormikDatePicker";
import FormikSelectInput from "@/components/forms/FormikSelectInput";
import * as Yup from "yup";
import dayjs from "dayjs";
import ReusableButton from "@/components/buttons/StyledButton";
import FormikMonthYearPicker from "@/components/forms/FormikMonthYearPicker";
import { format } from 'date-fns'; 
import moment from "moment";

const FilterForm = ({ fields, onSubmit, onReset, selectedMonth, setSelectedMonth }) => {
  // Initial values setup
  // const initialValues = fields.reduce((acc, field) => {
  //   acc[field.name] = field.initialValue || ""; // Set initial values if provided, otherwise empty
  //   return acc;
  // }, {});

  const initialValues = fields.reduce((acc, field) => {
    acc[field.name] = field.type === "month" ? (selectedMonth || null) : field.initialValue || "";
    return acc;
  }, {});

  // Dynamic validation schema based on field type
  const validationSchema = Yup.object().shape(
    fields.reduce((acc, field) => {
      if (field.required) {
        if (field.type === "date") {
          acc[field.name] = Yup.date().required(`${field.label} is required`);
        } else {
          acc[field.name] = Yup.string().required(`${field.label} is required`);
        }
      }
      return acc;
    }, {})
  );

  return (
    <Formik
      // initialValues={initialValues}
      initialValues={{ initialValues, startDate: selectedMonth ? moment(selectedMonth, "MM-YYYY").format("MMMM YYYY") : "" }}
      validationSchema={validationSchema}
      // onSubmit={onSubmit}
      onSubmit={(values) => {
              
              setSelectedMonth(values.startDate);
              // setDataTableKey((prevKey) => prevKey + 1);
            }}
    >
      {({ setFieldValue, resetForm, values }) => (
        <Form>
          <Grid container spacing={2} alignItems="center" sx={{ mb: "15px" }}>
            {fields.map((field) => (
              <Grid
                key={field.name}
                item
                xs={12} // Full width on mobile
                sm={6} // Half width on tablets
                md={4} // One-third width on medium screens
                lg={3} // Quarter width on large screens
              >
                {/* Render Select Inputs */}
                {field.type === "select" && (
                  <FormikSelectInput
                    name={field.name}
                    label={field.label}
                    options={field.options || []}
                    placeholder={field.placeholder || `Select ${field.label}`}
                    disabled={field.disable || false}
                    required={field.required || false}
                    search={true}
                    onChange={(event) => {
                            const value = event.target.value;
                            const name = field.name;
                            setFieldValue(name, value); // Update Formik state
                            // Call your custom onChange with correct name + value
                            field.onChange?.({
                              target: {
                                name,
                                value,
                              },
                            });
                          }}
                    // onChange={(event) => {
                    //   const value = event.target.value;
                    //   setFieldValue(field.name, value); // Update Formik state
                    //   field.onChange?.(event); // Log value if onChange is defined
                    // }}
                  />
                )}

                {/* Render Date Inputs */}
                {field.type === "month" && (
                  <FormikMonthYearPicker
                    name={field.name}
                    label={field.label}
                    pickerType="month"
                    placeholder="Select Month & Year"
                    value={values[field.name] ? moment(values[field.name]).toDate() : null}
                    onChange={(date) => {
                      const formattedDate = date ? moment(date).format("MM-YYYY") : "";
                      setFieldValue(field.name, formattedDate);
                      setSelectedMonth(formattedDate);
                      field.onChange?.(formattedDate);
                    }}
                    maxDate={new Date()}
                  />
                )}
              </Grid>
            ))}

            {/* Clear Button */}
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <ReusableButton
                label="Clear"
                onClick={() => {
                  resetForm(); // Reset Formik state
                  onReset?.(); // Call custom onReset if provided
                  setSelectedMonth(moment().format("MM-YYYY"));
                }}
                sx={{ marginTop: "10px" }}
                variant="outlined"
                size="small"
                type="reset"
                color="error"
                // fullWidth // Ensures button is responsive
              />
            </Grid>
          </Grid>
        </Form>
      )}
    </Formik>
  );
};

export default FilterForm;
